export enum NOTIFICATION_IDS {
  CREDIT_ENRICHED_SUCCESS = "CREDIT_ENRICHED_SUCCESS",
  ENTITY_AUDIT_LOG = "ENTITY_AUDIT_LOG",
  INTERNAL_NOTES = "INTERNAL_NOTES",
}
